import { FC } from "react";
import { useGetOneByIdQuery } from "../../features/api/Api";
import { isExists } from "../../utils";

interface IReferenceField {
  data: any;
  reference: string;
  optionname: string;
}

const RefField: FC<IReferenceField> = (props) => {
  const { data, reference, optionname } = props;

  const { data: record }: any = useGetOneByIdQuery(
    {
      resource: reference,
      id: data,
    },
    { skip: !isExists(data) }
  );

  if (!isExists(record?.data)) {
    return null;
  }

  return <>{record.data[optionname]} </>;
};

export default RefField;
